import { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import { lazyRoute } from '@/routing/lazyRoute';
import { approvalAnswerStore } from '@/stores/ApprovalAnswerStore';

const ApprovalAnswerToast = lazyRoute(
  () => import('./ApprovalAnswerToast'),
  (module) => module.ApprovalAnswerToast,
);

/**
 * UXA-9: where `ApprovalAnswerToast` mounts (`Layout.tsx`), loaded only once an answer is held or
 * refused, so the launch carries the store and nothing of the review screen's words or requests.
 */
export const ApprovalAnswerToastSlot = observer(function ApprovalAnswerToastSlot() {
  if (!approvalAnswerStore.held && !approvalAnswerStore.refusal) return null;
  return (
    <Suspense fallback={null}>
      <ApprovalAnswerToast />
    </Suspense>
  );
});
